import React from 'react';

import { ErrorResponse, RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { ErrorCard } from '@eika/card';
import { RichIconTypes } from '@eika/rich-icon';

import { useTranslation } from '../translations';

interface Props {
    exception: RequestExceptionWithResponse | ErrorResponse | undefined;
    children?: React.ReactNode;
}

const ErrorCardWrapper: React.FC<Props> = ({ exception, children }) => {
    const translated = useTranslation();

    return (
        <ErrorCard
            title={translated.errors.somethingWentWrong}
            exception={exception}
            description={translated.errors.defaultMessage}
            errorCodeHeader={translated.errors.errorCodeHeader}
            copyErrorCode={translated.errors.copyErrorCode}
            goBack={translated.goBack}
            icon={RichIconTypes.NETTVERKSBRUDD_2}
            informationModalProps={{
                title: translated.errors.informationModalTitle,
                description: translated.errors.informationModalDescription,
            }}
        >
            {children}
        </ErrorCard>
    );
};

export default ErrorCardWrapper;
